import styled from 'astroturf/react';

const ProgressVisualFull = styled('div')`
    display: flex;
    height: 10px;
    margin: 0 0 10px 0;
    background: var(--ph-gray-250);
`;

const ProgressVisualPart = styled('div')`
    transition: width 2s;
`;

const ProgressLegend = styled('div')`
    display: flex;    
    justify-content: space-between;
`;

const ProgressLegendWrapper = styled('div')`    
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: space-between;
    &:last-child {            
        margin-left: auto;
        margin-right: 0;
    }
    &:first-child {      
        margin-left: 0; 
    }
`;

const ProgressLegendPart = styled('div')`
    width: 10px;
    height: 10px;
`;

const ProgressLegendLabelWrapper = styled('div')`
    margin-left: 5px;
    margin-right: auto;
`;

const ProgressLegendLabel = styled('div')`    
  font-family: var(--ph-font-family-source-sans-pro);
  font-size: 11px;
  line-height: 1;
  white-space: pre-wrap;
`;

const ProgressLegendPercentage = styled('div')`    
  font-family: var(--ph-font-family-lato-bold);
  font-size: 16px;
`;

export default {
    ProgressVisualFull,
    ProgressVisualPart,
    ProgressLegend,
    ProgressLegendWrapper,
    ProgressLegendPart,
    ProgressLegendLabelWrapper,
    ProgressLegendLabel,
    ProgressLegendPercentage
}
